import request from '@/utils/request'

export function fetchSupplierList (query) {
  return request({
    url: '/card/api/group_supplier/index',
    method: 'get',
    params: query
  })
}

export function fetchSupplier (id) {
  return request({
    url: '/card/api/group_supplier/view',
    method: 'get',
    params: { id }
  })
}

export function createSupplier (data) {
  return request({
    url: '/card/api/group_supplier/insert',
    method: 'post',
    data
  })
}

export function updateSupplier (data) {
  return request({
    url: '/card/api/group_supplier/update',
    method: 'post',
    data
  })
}

export function deleteSupplier (id) {
  return request({
    url: '/card/api/group_supplier/delete',
    method: 'post',
    params: { id }
  })
}



// WEBPACK FOOTER //
// ./src/card/api/group-supplier.js